import { CssBaseline } from "@mui/material";
import { ThemeProvider } from "@mui/material/styles";
import { useEffect, useState } from "react";
import MuiXLicense from "./api/config";
import './assets/scss/main.scss';
import { PushNotification } from "./components/molecules/notificationToaster";
import { ToasterComponent } from "./components/molecules/toasterComponent";
import Routing from "./routing/routeComponent";
import theme from "./theme/theme";
import { NewToasterComponent } from './components/atoms/newToasterComponent';
import AwaitedSurfaces from "./builderPackage/components/awaitedSurfaces/awaitedSurfaces";
// import { Offline } from "react-detect-offline";
import ReactGA from "react-ga4";
import { USER_PROFILE_DATA } from "./api/url";
import { getLocalStorageItem } from "./utils/storageHelper";
// import mixpanel from 'mixpanel-browser';
import { Analytics } from "./constants";
import WakeLock from "./components/atoms/WakeLock";
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import NoMenuListDialog from "./components/templates/NoMenuListDialog";
dayjs.extend(utc);
dayjs.extend(timezone);
function App() {
    var _a = useState(), isTokenFound = _a[0], setTokenFound = _a[1];
    var TRACKING_ID = 'G-J694B7VWBC'; // Replace with your GA4 Measurement ID
    if (Analytics.GA) {
        ReactGA.initialize(TRACKING_ID);
    }
    var profile = getLocalStorageItem(USER_PROFILE_DATA);
    var clearCacheData = function () {
        caches.keys().then(function (names) {
            names.forEach(function (name) {
                caches.delete(name);
            });
        }).catch(function (err) {
            console.log(err);
        });
    };
    useEffect(function () {
        if (window.caches)
            clearCacheData();
    }, []);
    useEffect(function () {
        if (Analytics.GA) {
            var _profile$data, _profile$data2;
            ReactGA.send({
                hitType: "WindowLocationPathName",
                page: window.location.pathname
            });
            ReactGA._gaCommandSendPageview(window.location.pathname, {
                title: 'User Name',
                product_id: (profile === null || profile === void 0 || (_profile$data = profile.data) === null || _profile$data === void 0 ? void 0 : _profile$data.GivenName) + (profile === null || profile === void 0 || (_profile$data2 = profile.data) === null || _profile$data2 === void 0 ? void 0 : _profile$data2.FamilyName)
            });
            if (window.gtag) {
                window.gtag('config', TRACKING_ID, {
                    page_path: location.pathname,
                    page_name: ''
                });
            }
        }
        if (Analytics.MixPanel) {
            // mixpanel.init('317cd918cd1be85afe805c99c4b31aff', {
            // 	debug: true, // Enables debugging logs
            // 	persistence: 'localStorage', // Ensures data persists across sessions
            // });
            // mixpanel.track('Page View', {
            // 	page: window.location.pathname,
            // });
        }
    }, []);
    // useEffect(() => {
    // 	requestPermission()
    // 	getSavedNotificationList()
    // }, []);
    // function requestPermission() {
    // 	Notification.requestPermission().then((permission) => {
    // 		if (permission === 'granted') {
    // 			 getFCMToken(setTokenFound)
    // 		}else{
    // 			console.log("I am in else condition")
    // 		}
    // 	})
    // }
    // onMessageListener().then((payload) => {
    // 	handleNotification(payload)
    // }).catch((err) => console.log("failed: ", err));
    // const handleNotification = async(payload: MessagePayload) => {
    // 	let data: any = []
    // 	data = {
    // 		body: payload.notification?.body,
    // 		title: payload.notification?.title,
    // 	};
    //   const result : any = await saveNotifications(data)
    //   dispatch(showPushNotification({
    // 	isOpen: true,
    // 	message: payload.notification?.body,
    // }));
    //   dispatch(setNotificationList(result)) 
    // }
    // const getSavedNotificationList = async()=>{
    // 	const result : any = await getSaveNotifications()
    // 	dispatch(setNotificationList(result)) 
    // }
    // useEffect(() => {
    // 	let touchStartY = 0;
    // 	const preventPullToRefresh = (e: any) => {
    // 		if (e.touches.length === 1) { // Only handle single finger touch
    // 			const touchCurrentY = e.touches[0].clientY;
    // 			// Detect if the user is at the top of the page
    // 			const scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
    // 			// If the user is at the top and pulls down, prevent the default action (pull-to-refresh)
    // 			if (scrollTop === 0 && touchCurrentY > touchStartY) {
    // 				e.preventDefault(); // Prevent pull-to-refresh
    // 			}
    // 			touchStartY = touchCurrentY; // Track the starting Y position for scrolling direction
    // 		}
    // 	};
    // 	// Listen for touchstart and touchmove events
    // 	document.addEventListener('touchstart', (e) => {
    // 		if (e.touches.length === 1) {
    // 			touchStartY = e.touches[0].clientY; // Capture the initial touch position
    // 		}
    // 	}, { passive: false });
    // 	document.addEventListener('touchmove', preventPullToRefresh, { passive: false });
    // 	return () => {
    // 		// Cleanup event listeners
    // 		document.removeEventListener('touchstart', (e) => { });
    // 		document.removeEventListener('touchmove', preventPullToRefresh);
    // 	};
    // }, []);
    return /*#__PURE__*/ React.createElement(ThemeProvider, {
        theme: theme
    }, /*#__PURE__*/ React.createElement(CssBaseline, null), /*#__PURE__*/ React.createElement(NoMenuListDialog, null), /*#__PURE__*/ React.createElement(Routing, null), /*#__PURE__*/ React.createElement(MuiXLicense, null), /*#__PURE__*/ React.createElement(ToasterComponent, null), /*#__PURE__*/ React.createElement(PushNotification, null), /*#__PURE__*/ React.createElement(NewToasterComponent, null), /*#__PURE__*/ React.createElement(AwaitedSurfaces, null), /*#__PURE__*/ React.createElement(WakeLock, null));
}
export default App;
